import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutLeft"><Path d="M6.5 3.5L20.5 3.5L20.5 20.5H6.5L6.5 3.5Z" stroke="currentColor"/><Path d="M3.5 3V21" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutLeft;
